<template>
  <div @click="toggleDetailsModal" class="announce">
    <h3>{{ announcement.title }}</h3>
    <p>{{ snippet }}<span>More</span></p>
  </div>
  <div v-if="showDetailsModal">
    <ClassAnnouncementDetails
      :announcement="announcement"
      @close="toggleDetailsModal"
      @deletion="Adeletion"
    />
  </div>
</template>

<script>
import { computed, ref } from '@vue/reactivity'
import ClassAnnouncementDetails from './ClassAnnouncementDetails.vue'
export default {
  props: ['announcement'],
  emits: ['announcementdeleted'],
  components: { ClassAnnouncementDetails },
  setup (props, context) {
    const showDetailsModal = ref(false)
    const snippet = computed(() => {
      return props.announcement.content.substring(0, 100) + '... '
    })

    const toggleDetailsModal = () => {
      showDetailsModal.value = !showDetailsModal.value
    }
    const Adeletion = () => {
      context.emit('announcementdeleted')
    }
    return { toggleDetailsModal, showDetailsModal, snippet, Adeletion }
  }
}
</script>

<style>
  .announce {
      cursor: pointer;
      margin-bottom: 10px;
  }
  .announce h3 {
      color: var(--inspire-charcoal) ;
  }
  .announce p {
      color: #777 ;
  }
  .announce p span {
      text-decoration: underline;
  }
</style>
